import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'
import { useAuthState } from '@percent/cause-dashboard/common/hooks/useAuthState/useAuthState'

const isSocialImpact = (org?: { type?: string; types?: string[] }) =>
  org?.type === 'social_impact' || (org?.types?.length === 1 && org.types.includes('social_impact'))

export const useSocialImpactOrg = () => {
  const { authState } = useAuthState()

  const socialImpactRoutes: string[] = [
    RoutePath.PROFILE,
    RoutePath.GRANTS,
    RoutePath.VOLUNTEERING,
    RoutePath.MY_ACCOUNT,
    RoutePath.USERS,
    RoutePath.SIGNIN_2FA_RECOVERY,
    RoutePath.SIGNIN_2FA,
    RoutePath.SIGNIN_2FA_SETUP
  ]

  const isSocialImpactOrg = isSocialImpact(authState.organisation) || isSocialImpact(authState.claimOrganisation)

  const isSocialImpactRoute = (pathname: string) => socialImpactRoutes.some(route => pathname.startsWith(route))

  return { isSocialImpactOrg, socialImpactRoutes, isSocialImpactRoute }
}
